import { Routes } from '@angular/router';
import { authGuard } from './guards/auth.guard';
import { adminGuard } from './guards/admin.guard';
import { legacyLoginGuard } from './guards/legacy-login.guard';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./pages/landing/landing.component').then(m => m.LandingComponent)
  },
  {
    path: 'login',
    loadComponent: () => import('./pages/login/login.component').then(m => m.LoginComponent),
    canMatch: [legacyLoginGuard]
  },
  {
    path: 'onboarding',
    loadComponent: () => import('./pages/onboarding/onboarding.component').then(m => m.OnboardingComponent)
  },
  {
    path: 'customers',
    loadComponent: () => import('./pages/customers/customers.component').then(m => m.CustomersComponent),
    canActivate: [authGuard]
  },
  {
    path: 'admin',
    loadComponent: () => import('./pages/admin/admin-users.component').then(m => m.AdminUsersComponent),
    canActivate: [adminGuard]
  },
  {
    path: 'email-templates',
    loadComponent: () => import('./pages/email-templates/email-templates.component').then(m => m.EmailTemplatesComponent),
    canActivate: [authGuard]
  },
  {
    path: 'alert-policies',
    loadComponent: () => import('./pages/alert-policies/alert-policies.component').then(m => m.AlertPoliciesComponent),
    canActivate: [authGuard]
  },
  {
    path: 'settings',
    loadComponent: () => import('./pages/settings/settings.component').then(m => m.SettingsComponent),
    canActivate: [authGuard]
  },
  {
    path: 'scheduler',
    loadComponent: () => import('./pages/scheduler/scheduler.component').then(m => m.SchedulerComponent),
    canActivate: [authGuard]
  },
  {
    path: 'profile',
    loadComponent: () => import('./pages/profile/profile.component').then(m => m.ProfileComponent),
    canActivate: [authGuard]
  },
  {
    path: 'first-time',
    loadComponent: () =>
      import('./pages/first-time-password-reset/first-time-password-reset.component').then(
        m => m.FirstTimePasswordResetComponent
      )
  },
  {
    path: 'sql-query',
    loadComponent: () => import('./pages/sql-query/sql-query.component').then(m => m.SqlQueryComponent),
    canActivate: [adminGuard]
  },
  {
    path: 'msp-company',
    loadComponent: () => import('./pages/msp-company/msp-company.component').then(m => m.MspCompanyComponent),
    canActivate: [adminGuard]
  },
  { path: '**', redirectTo: '' }
];
